module.exports = __webpack_public_path__ + "static/ibotta_logo3-ee19bb734d440fde040aebe87cd67e88.png";